var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldNoteRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.03 1C1.76 1 1 1.76 1 3.03v2.94C1 7.24 1.76 8 3.03 8h2.94C7.24 8 8 7.24 8 5.97V3.03C8 1.76 7.24 1 5.97 1H3.03zm3.44 5.47a.661.661 0 0 1-.91 0L4.49 5.41 3.45 6.47a.674.674 0 0 1-.92 0 .646.646 0 0 1 0-.91L3.6 4.5 2.54 3.45a.646.646 0 0 1 0-.91c.25-.25.66-.25.91 0L4.49 3.6l1.06-1.06c.25-.25.66-.25.91 0s.25.66 0 .91L5.41 4.5l1.06 1.06c.25.25.25.66 0 .91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.32 16.25-5.51 5.55c-.13.14-.3.2-.47.2-.33 0-.65-.26-.65-.64v-3.5c0-1.46 1.24-2.67 2.76-2.67.95-.01 2.27-.01 3.4-.01.39 0 .65.31.65.64 0 .15-.05.3-.18.43z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.32 16.25-5.51 5.55c-.13.14-.3.2-.47.2-.33 0-.65-.26-.65-.64v-3.5c0-1.46 1.24-2.67 2.76-2.67.95-.01 2.27-.01 3.4-.01.39 0 .65.31.65.64 0 .15-.05.3-.18.43z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2c-.55 0-1 .45-1 1v3.5c0 1.66-1.34 3-3 3h-3c-.55 0-1 .45-1 1v6.63A4.87 4.87 0 0 0 7.37 22h4.82c.55 0 1-.45 1-1v-3.14c0-2.3 1.91-4.17 4.26-4.17.53-.01 1.82-.01 3.05-.01.55 0 1-.44 1-1V6.87A4.87 4.87 0 0 0 16.63 2H10.5zM6.08 17.01a.755.755 0 0 1 0-1.51h2.64c.43 0 .75.34.75.76 0 .41-.32.75-.75.75H6.08zm0-3.71a.755.755 0 0 1 0-1.51h5.43c.41 0 .76.34.76.76 0 .41-.35.75-.76.75H6.08z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldNoteRemove);
export default __webpack_public_path__ + "static/media/vuesax-bold-note-remove.d3362127ae25a5b3e7aff216b7e900d8.svg";
export { ForwardRef as ReactComponent };